// extracted by mini-css-extract-plugin
export default {"mainPanel":"MainPanel_mainPanel__-OHlx"};